import request from '@/utils/request'
//运费模板列表
export function freightList (params) {
  return request({
    url: '/freight',
    method: 'get',
    params: params
  })
}
//添加模板
export function addTheTemplate (data) {
  return request({
    url: '/freight/create',
    method: 'post',
    data: data
  })
}
//删除模板
export function deleteTheTemplate (id) {
  return request({
    url: '/freight/delete/' + id,
    method: 'get',
  })
}
//更新模板
export function updateTheTemplate (id, data) {
  return request({
    url: '/freight/update/' + id,
    method: 'post',
    data: data
  })
}
//根据编号查询运费模板
export function getFreight (id) {
  return request({
    url: '/freight/' + id,
    method: 'get',
  })
}

//全店使用
export function useModel (id) {
  return request({
    url: '/freight/usemodel/' + id,
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/freightManage.js